import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=577cd26c"
import script from "./SearchPage.vue?vue&type=script&lang=ts"
export * from "./SearchPage.vue?vue&type=script&lang=ts"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=577cd26c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports